import { CURRENT_COUNTRY } from "./constants";
import isBundleWithSubProducts from "./bundle";
const IS_CH_MARKET = CURRENT_COUNTRY === "ch";

// const discountsForWeight10To16 = IS_CH_MARKET
// 	? ["Amount_Off_2_CHF_Benefit", "Amount_Off_4_CHF_Benefit_Autumn_Bundle", "Amount_Off_6_CHF_Benefit"]
// 	: ["Amount_Off_1_EUR_Benefit", "Amount_Off_2_EUR_Benefit_Autumn_Bundle", "Amount_Off_3_EUR_Benefit"];

// const discountsForWeight16To20 = IS_CH_MARKET
// 	? ["Amount_Off_4_CHF_Benefit", "Amount_Off_8_CHF_Benefit_Autumn_Bundle", "Amount_Off_12_CHF_Benefit",]
// 	: ["Amount_Off_2_EUR_Benefit", "Amount_Off_4_EUR_Benefit__Autumn_Bundle", "Amount_Off_6_EUR_Benefit"];

// const discountsForWeightAbove20 = IS_CH_MARKET
// 	? ["Amount_Off_5_CHF_Benefit", "Amount_Off_10_CHF_Benefit_Autumn_Bundle", "Amount_Off_15_CHF_Benefit",]
// 	: ["Amount_Off_2.5_EUR_Benefit", "Amount_Off_5_EUR_Benefit__Autumn_Bundle", "Amount_Off_7.5_EUR_Benefit"];
const discountsForWeight10To16 = IS_CH_MARKET
	? ["Amount_Off_2_CHF_Benefit", "Amount_Off_6_CHF_Benefit"]
	: ["Amount_Off_1_EUR_Benefit", "Amount_Off_3_EUR_Benefit"];

const discountsForWeight16To20 = IS_CH_MARKET
	? ["Amount_Off_4_CHF_Benefit", "Amount_Off_12_CHF_Benefit"]
	: ["Amount_Off_2_EUR_Benefit", "Amount_Off_6_EUR_Benefit"];

const discountsForWeightAbove20 = IS_CH_MARKET
	? ["Amount_Off_5_CHF_Benefit", "Amount_Off_15_CHF_Benefit"]
	: ["Amount_Off_2.5_EUR_Benefit", "Amount_Off_7.5_EUR_Benefit"];

const normalizeLineLabel = (value) => (typeof value === "string" ? value.trim().toLowerCase() : "");

const isBundleLine = (line = {}) => {
	if (isBundleWithSubProducts(line)) return true;

	return [normalizeLineLabel(line?.name), normalizeLineLabel(line?.title)]
		.filter(Boolean)
		.some((label) => label.includes("bundle"));
};

const getWeightFromAttributes = (attributes = []) => {
	if (!Array.isArray(attributes)) return null;

	for (const attr of attributes) {
		const key = String(attr?.key || "").toLowerCase();
		if (!key) continue;
		if (key === "weightingrams" || key === "weight_in_grams") {
			const value = Number(attr?.value);
			if (Number.isFinite(value) && value > 0) return value;
		}
	}

	return null;
};

const getLineWeightInGrams = (line = {}) => {
	const explicitWeightInGrams = [
		line?.weightInGrams,
		line?.weight_in_grams,
		getWeightFromAttributes(line?.custom_attributes || line?.customAttributes),
	].find((value) => Number.isFinite(Number(value)) && Number(value) > 0);

	if (explicitWeightInGrams) return Number(explicitWeightInGrams);

	const variantWeight = Number(line?.variant?.weight);
	const variantWeightUnit = String(line?.variant?.weightUnit || "").toUpperCase();
	if (Number.isFinite(variantWeight) && variantWeight > 0) {
		if (variantWeightUnit === "GRAMS") return variantWeight;
		if (variantWeightUnit === "KILOGRAMS") return variantWeight * 1000;
	}

	const rawWeight = Number(line?.weight);
	if (!Number.isFinite(rawWeight) || rawWeight <= 0) return 0;

	if (rawWeight === 1) return 1;
	if (rawWeight < 20) return rawWeight * 1000;

	return rawWeight;
};

// function validDiscountContracts(lines) {
// 	const bundleDiscounts = {
// 		umami: false,
// 		comfort: false,
// 		others: false,
// 	};

// 	for (let i = 0; i < lines.length; i++) {
// 		const lineName = lines[i]?.name?.toLowerCase() || lines[i]?.title?.toLowerCase();

// 		const isBundle = lineName?.includes("bundle");
// 		const isUmami = lineName?.includes("umami");
// 		const isComfort = lineName?.includes("comfort");

// 		if (!isBundle) continue;

// 		if (isUmami) bundleDiscounts.umami = true;
// 		if (isComfort) bundleDiscounts.comfort = true;
// 		if (!isUmami && !isComfort) bundleDiscounts.others = true;
// 	}

// 	return bundleDiscounts;
// }

export const getSubscriptionDiscountsEversubs = (lines) => {
	const totalWeight = lines.reduce((acc, item) => {
		const quantity = Number(item?.quantity) || 1;
		return acc + (getLineWeightInGrams(item) / 1000) * quantity;
	}, 0);
	const hasBowls = lines.some((line) => !isBundleLine(line));
	const hasBundle = lines.some(line =>
		isBundleLine(line) &&
		getLineWeightInGrams(line) >= 2000);

	// const { umami, comfort, others } = validDiscountContracts(lines);

	const discounts = [];

	const addDiscounts = (discountList) => {
		if (hasBowls) {
			discounts.push(discountList[0]);
		}

		if (hasBundle) {
			// if (umami || comfort) discounts.push(discountList[2]);
			// if (others) discounts.push(discountList[1]);
		}
	};

	if (totalWeight >= 10 && totalWeight < 16) {
		addDiscounts(discountsForWeight10To16);
	} else if (totalWeight >= 16 && totalWeight < 20) {
		addDiscounts(discountsForWeight16To20);
	} else if (totalWeight >= 20) {
		addDiscounts(discountsForWeightAbove20);
	}

	return discounts;
};

// Amount_Off_X_EUR|CHF_Benefit__Autumn_Bundle
// Amount_Off_X_EUR|CHF_Benefit
const getSubscriptionDiscounts = (lines) => {
	const totalWeight = lines.reduce((acc, item) => {
		const quantity = Number(item?.quantity) || 1;
		return acc + (getLineWeightInGrams(item) / 1000) * quantity;
	}, 0);
	const hasBowls = lines.some((line) => !isBundleLine(line));
	// const { umami, comfort, others } = validDiscountContracts(lines);

	const hasBundle = lines.some(line =>
		isBundleLine(line) &&
		getLineWeightInGrams(line) >= 2000 &&
		!isBundleWithSubProducts(line)
	);

	const discounts = [];

	const addDiscounts = (discountList) => {
		if (hasBowls) {
			discounts.push(discountList[0]);
		}

		if (hasBundle) {
			// if (umami || comfort) discounts.push(discountList[2]);
			// if (others) discounts.push(discountList[1]);
		}
	};

	if (totalWeight >= 10 && totalWeight < 16) {
		addDiscounts(discountsForWeight10To16);
	} else if (totalWeight >= 16 && totalWeight < 20) {
		addDiscounts(discountsForWeight16To20);
	} else if (totalWeight >= 20) {
		addDiscounts(discountsForWeightAbove20);
	}

	return discounts;
};

export default getSubscriptionDiscounts;

// ============================================
// EVERSUBS SEQUENTIAL DISCOUNTS
// ============================================

export function getCurrentDiscountStep(metafields) {
	const discountMetafield = metafields?.find(
		mf => mf?.key === "discounts" && mf?.namespace === "eversubs"
	);

	if (!discountMetafield?.value) return null;

	try {
		const config = JSON.parse(discountMetafield.value);
		const activeDiscount = Array.isArray(config?.discounts)
			? config.discounts.find(d => d?.is_active) || config.discounts[0]
			: config;

		if (!activeDiscount) return null;

		const steps = activeDiscount.steps || [];

		// Prefer an active step when present (admin format)
		for (let i = 0; i < steps.length; i++) {
			const step = steps[i];
			const usageLimit = step?.recurring_cycle_limit ?? step?.max_usage ?? null;
			const isUsageAvailable = usageLimit === null || step?.usage_count < usageLimit;

			if (step?.is_active || isUsageAvailable) {
				return {
					...step,
					stepLabel: step.title || `Step ${i + 1}`,
					isInitial: false,
					currentStepIndex: i
				};
			}
		}

		return null; // No discount available
	} catch (e) {
		console.error("Failed to parse eversubs.discounts metafield:", e);
		return null;
	}
}

export function calculateSequentialDiscount(step, subtotal, currency = "EUR") {
	if (!step) {
		return { amount: 0, formatted: null, calculatedFormatted: null };
	}

	const currencySymbol = currency === "CHF" ? "CHF " : "€";
	const roundCurrencyDown = (value) => Math.floor((value + Number.EPSILON) * 100) / 100;

	if (step.value_type === "PERCENTAGE") {
		const amount = roundCurrencyDown((subtotal * step.value) / 100);
		return {
			amount,
			value: step.value,
			valueType: "PERCENTAGE",
			formatted: `${step.value}%`,
			calculatedFormatted: `${currencySymbol}${amount.toFixed(2)}`
		};
	}

	// FIXED amount
	const amount = roundCurrencyDown(Math.min(step.value, subtotal)); // Don't exceed subtotal
	return {
		amount,
		value: step.value,
		valueType: "FIXED",
		formatted: `${currencySymbol}${step.value}`,
		calculatedFormatted: `${currencySymbol}${amount.toFixed(2)}`
	};
}

export function getSequentialDiscountPreview(metafields, subtotal, currency = "EUR") {
	const step = getCurrentDiscountStep(metafields);

	if (!step) {
		return {
			hasDiscount: false,
			step: null,
			discount: null,
			label: null,
			message: null
		};
	}

	const discount = calculateSequentialDiscount(step, subtotal, currency);

	return {
		hasDiscount: true,
		step,
		discount,
		label: step.stepLabel,
		message: `${discount.formatted} off your order`,
		finalTotal: subtotal - discount.amount
	};
}

export function parseEversubsDiscountConfig(metafields) {
	const discountMetafield = metafields?.find(
		mf => mf?.key === "discounts" && mf?.namespace === "eversubs"
	);

	if (!discountMetafield?.value) return null;

	try {
		return JSON.parse(discountMetafield.value);
	} catch (e) {
		console.error("Failed to parse eversubs.discounts metafield:", e);
		return null;
	}
}
